<template>
  <table style="table-layout: fixed; border-collapse: collapse; font-family: Arial, Helvetica, sans-serif" width="100%">
    <tr>
      <td :align="align">
        <div :style="{ minWidth: minWidth, maxWidth: maxWidth, margin: margin }">
          <slot></slot>
        </div>
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'LayoutBase',
  props: {
    minWidth: {
      type: String,
      default: '288px',
    },
    maxWidth: {
      type: String,
      default: '420px',
    },
    margin: {
      type: String,
      default: '0',
    },
    align: {
      type: String,
      default: 'center',
    },
  },
}
</script>
